import type React from 'react';

import classNames from 'classnames';

import type { AssetsApprovalSchemaNullable } from '@iconik-io/iconik-api/src/services/assets';
import { Icon } from '@iconik-io/uad';

import type { StatusTooltipComponent } from './status_tooltip';

import styles from '../approval_detailed_status_icon.module.css';

export const InfoStatuses: React.FC<{
  requestedBy: AssetsApprovalSchemaNullable[];
  requestedByUser: boolean;
  StatusTooltip: StatusTooltipComponent;
}> = ({ requestedBy, requestedByUser, StatusTooltip }) => {
  const statuses = [];

  if (requestedBy.length > 0) {
    statuses.push(
      <div key="request-status" className={styles.status_content}>
        <StatusTooltip
          label={
            requestedByUser ? 'Review requested by you' : 'Awaiting review'
          }
        >
          <div className={styles.status_icon}>
            <Icon
              name={
                requestedByUser
                  ? 'ra_approval_requested_to_me'
                  : 'ra_approval_requested'
              }
            />
          </div>
        </StatusTooltip>
        {requestedBy.length > 1 ? (
          <div className={styles.counter}>{requestedBy.length}</div>
        ) : null}
      </div>,
    );
  }

  if (statuses.length > 0) {
    return (
      <div className={classNames(styles.status_info, styles.status)}>
        {statuses}
      </div>
    );
  }
  return null;
};
